export default "__VITE_ASSET__1XsPcgNQ__"